"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoaModal = void 0;
var react_1 = __importDefault(require("react"));
var ModalWrapper_1 = require("./ModalWrapper");
var baseUrl = "https://storage.googleapis.com/icstorage/";
exports.CoaModal = function (props) {
    var onClose = props.onClose, onSubmit = props.onSubmit, _a = props.defaultValues, defaultValues = _a === void 0 ? {
        ArtworkTitle: "",
        ArtistName: "",
        // PrintDate: "",
        // PrintSize: "",
        // PrintMedium: "",
        CountryOfOrigin: "",
        Edition: ""
    } : _a, _b = props.style, style = _b === void 0 ? { maxWidth: "970px", backgroundColor: "white" } : _b;
    // console.log("defaultValues", defaultValues);
    var _c = react_1.default.useState(__assign({ ArtworkTitle: "", ArtistName: "", 
        // PrintDate: "",
        // PrintSize: "",
        // PrintMedium: "",
        CountryOfOrigin: "", Edition: "" }, defaultValues)), state = _c[0], setState = _c[1];
    var handleSubmit = function () {
        onSubmit(__assign(__assign({}, state), { enabled: true }));
        handleClear();
        close();
    };
    var handleClear = function () {
        setState({
            ArtworkTitle: "",
            ArtistName: "",
            // PrintDate: "",
            // PrintSize: "",
            // PrintMedium: "",
            CountryOfOrigin: "",
            Edition: ""
        });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ModalWrapper_1.ModalWrapper, { isOpen: true, onClose: onClose, style: style },
            react_1.default.createElement("div", { className: "layout-form-wrapper2" },
                react_1.default.createElement("div", { className: "row justify-content-center mt-3 mt-md-4" },
                    react_1.default.createElement("form", null,
                        react_1.default.createElement("div", { className: "form-group" },
                            react_1.default.createElement("label", null, "Artwork Title:"),
                            react_1.default.createElement("div", { className: "form-control-inner-wrapper" },
                                react_1.default.createElement("input", { type: "text", className: "form-control", value: state.ArtworkTitle, onChange: function (e) {
                                        return setState(__assign(__assign({}, state), { ArtworkTitle: e.target.value }));
                                    } }))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("label", null, "Artist Name:"),
                            react_1.default.createElement("input", { type: "text", className: "form-control", value: state.ArtistName, onChange: function (e) {
                                    return setState(__assign(__assign({}, state), { ArtistName: e.target.value }));
                                } })),
                        react_1.default.createElement("div", { style: { display: "none" } },
                            react_1.default.createElement("label", null, "Print Size:"),
                            react_1.default.createElement("input", { type: "text", className: "form-control", value: state.PrintSize, onChange: function (e) {
                                    return setState(__assign(__assign({}, state), { PrintSize: e.target.value }));
                                } })),
                        react_1.default.createElement("div", { style: { display: "none" } },
                            react_1.default.createElement("label", null, "Print Medium:"),
                            react_1.default.createElement("input", { type: "text", className: "form-control", value: state.PrintMedium, onChange: function (e) {
                                    return setState(__assign(__assign({}, state), { PrintMedium: e.target.value }));
                                } })),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("label", null, "Country of Origin:"),
                            react_1.default.createElement("input", { type: "text", className: "form-control", value: state.CountryOfOrigin, onChange: function (e) {
                                    return setState(__assign(__assign({}, state), { CountryOfOrigin: e.target.value }));
                                } })),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("label", null, "Edition Details:"),
                            react_1.default.createElement("input", { type: "text", className: "form-control", value: state.Edition, onChange: function (e) {
                                    return setState(__assign(__assign({}, state), { Edition: e.target.value }));
                                } })),
                        react_1.default.createElement("div", { style: { paddingTop: "2rem" } },
                            react_1.default.createElement("button", { type: "button", className: "btn btn-primary", onClick: handleSubmit, style: {
                                    backgroundColor: "var(--pink)",
                                    color: "white",
                                    marginRight: "1rem"
                                } }, "Save + Add to Product"),
                            react_1.default.createElement("button", { type: "button", className: "btn btn-primary", onClick: handleClear }, "Clear Form"))))))));
};
